import { jsx as r } from "react/jsx-runtime";
import * as o from "react";
import { cn as g } from "../../utils/cn.js";
const a = o.forwardRef(({ className: t, ...s }, e) => /* @__PURE__ */ r(
  "textarea",
  {
    className: g(
      "gst-flex gst-min-h-[60px] gst-w-full gst-rounded-md gst-border gst-border-input gst-bg-transparent gst-ring-offset-2 gst-px-3 gst-py-2 gst-text-base gst-shadow-sm placeholder:gst-text-muted-foreground focus-visible:gst-outline-none focus-visible:gst-ring-2 focus-visible:gst-ring-ring disabled:gst-cursor-not-allowed disabled:gst-opacity-50 md:gst-text-sm",
      t
    ),
    ref: e,
    ...s
  }
));
a.displayName = "Textarea";
export {
  a as default
};
